import template from "./user-name.html";

const UserNameComponent = {
  template: template,
  controller: class UserNameController {
    /* @ngInject */
    constructor($rootScope, $scope) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
    }

    $onInit() {
      this.name = this.$rootScope.user.displayName;

      this.$scope.$on("refreshUser", () => {
        this.name = this.$rootScope.user.displayName;
      });
    }
  },
};

export default UserNameComponent;
